import { useI18n } from 'domains/i18n/hooks'
import EventDivider from 'ui/components/conversation/event-divider'
import { dividerKeys } from 'ui/utils/seamly-utils'

const dividerTypes = {
  [dividerKeys.new_topic]: 'new-topic',
}

const Divider = ({ event }) => {
  const { t } = useI18n()

  const { subtype } = event.payload.body
  const dividerType = dividerTypes[dividerKeys[subtype]]

  return dividerKeys[subtype] ? (
    <EventDivider
      dividerType={dividerType}
      iconName={dividerKeys[subtype]}
      title={t(`dividerKeys.${dividerKeys[subtype]}`)}
    />
  ) : null
}

export default Divider
